module.exports = __webpack_public_path__ + "img/wallets-c.a49ee568.svg";